const arrivalDelayTimeKPI = "arrival.delay duration.kpi";
const arrivalDelayReasonKPI = "arrival.delay code.kpi";
const departureDelayTimeKPI = "departure.delay duration.kpi";
const departureDelayReasonKPI = "departure.delay code.kpi";

export const otpKPIColumns = [
  arrivalDelayTimeKPI,
  arrivalDelayReasonKPI,
  departureDelayTimeKPI,
  departureDelayReasonKPI,
];

export const slotAdherenceKPIColumns = [
  arrivalDelayTimeKPI,
  arrivalDelayReasonKPI,
  departureDelayTimeKPI,
  departureDelayReasonKPI,
];

export const turnaroundSufficiencyKPIColumns = [
  "common.ETAT.kpi",
  "common.ATAT.kpi",
];

export const additionalDelayKPIColumns = [
  "common.ETAT.kpi",
  "common.ATAT.kpi",
  arrivalDelayTimeKPI,
  arrivalDelayReasonKPI,
  departureDelayTimeKPI,
  departureDelayReasonKPI,
  "common.turnaround Delay.kpi",
];
